<template>
<div>
    <Breadcrumbs main="Admin" submain="Submission" title="Student Submission" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="submission_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="data">
                                        <div style="max-width: 250px;">
                                            {{ data.item?.title }}
                                        </div>
                                    </template>

                                    <template #cell(location)="data">
                                        <div style="max-width: 200px;">
                                            {{ data.item?.location?.name }}
                                        </div>
                                    </template>

                                    <template #cell(banner)="data">
                                        <div style="max-width: 200px;">
                                            <img style="height: 80px; border-radius: 8px;" :src="host + data.item?.banner" alt="Banner">
                                        </div>
                                    </template>
                                    
                                    <!-- <template #cell(short_desc)="row">
                                        <div v-if="row.item.short_desc && row.item.short_desc.length > 200" style="max-width: 400px;">
                                            <div v-html="row.item.short_desc.slice(0, 200) + '...'"></div>
                                        </div>
                                        <div v-else style="max-width: 400px;">
                                            <div v-html="row.item.short_desc"></div>
                                        </div>
                                    </template> -->

                                    <template #cell(participant)="row">
                                        <div v-if="row.item" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.first_name }} {{ row.item.last_name }}</h7>
                                            <h7>{{ row.item.email }}</h7>
                                            <h7>{{ row.item.phone }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="20px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteResearch(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div>
                                                <router-link :to="{ name: 'SubmissionDetails', params: { id: data.item.slug } }">   
                                                    <feather type="eye" size="22px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="View"></feather>
                                                </router-link>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Words Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this item?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import router from '../../../router';

export default {
    components: {
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'banner',
                    label: 'Banner',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: true
                },
                {
                    key: 'participant',
                    label: 'Participant',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            delete_value: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            submission_list: state => state.words.submission_list,
            loading: state => state.words.submissionLoading,
            error: state => state.words.submissionError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("words/fetchStudentSubmissions").then(() => {
            this.items = this.submission_list
            this.totalRows = this.submission_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        deleteResearch(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("words/deleteSubmission", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
